export interface IVideoResponse {
  status: string
  result: ILink
}

export interface ILink {
  link: string
}

export enum TypesKppLP {
  aero = 'aero',
  vniief = 'vniief',
}
